import React, {useState, useEffect} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';
import Loader from '../../../components/Loader';
import SidebarFilter from '../../../components/SidebarFilter';
import { useSelector, locationActions, userActions, paymentsActions} from "inbooma-api";
import {Biscuit, getAllUrlParams} from "../../../../utils";
import {$,moment} from '../../../../../vendor';

const AdminTransactionsSidebar = (props) => {

    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href)
    allUrlParams?.client_name !== undefined && delete allUrlParams.client_name;
    allUrlParams?.payment_type_name !== undefined && delete allUrlParams.payment_type_name;
    allUrlParams?.payment_status_name !== undefined && delete allUrlParams.payment_status_name;
    allUrlParams?.month_name !== undefined && delete allUrlParams.month_name;
    let language = Biscuit.get('user.lang').replace('-','_');
    const cleanState = {clientFilter:false,paymentMethodFilter:false,paymentStatusFilter:false,fromFilter:false,toFilter:false,quickTimeFilter:false,monthFilter:false};
    const [usedFilterCount,setUsedFilterCount] = useState(
        {clientFilter:allUrlParams?.client_id !== undefined ? true : false,
            paymentMethodFilter:allUrlParams?.payment_type !== undefined ? true : false,
            paymentStatusFilter:allUrlParams?.paystate !== undefined ? true : false,
            fromFilter:allUrlParams?.date_gte !== undefined ? true : false,
            toFilter:allUrlParams?.date_lte !== undefined ? true : false,
            quickTimeFilter:allUrlParams?.date_gte !== undefined && allUrlParams?.date_lte !== undefined ? true : false,
            monthFilter:allUrlParams?.date_gte !== undefined && allUrlParams?.date_lte !== undefined ? true : false
        });
    const [filterCount, setFilterCount] = useState(Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0);
    const [clientFilter, setClientFilter] = useState(searchParams.get("client_id") !== null ? searchParams.get("client_id") : 'all');
    const [paymentMethodFilter, setPaymentMethodFilter] = useState(searchParams.get("payment_type") !== null ? searchParams.get("payment_type"): '');
    const [paystateFilter, setPaystateFilter] = useState(searchParams.get("paystate") !== null ? searchParams.get("paystate") : '');

    const [ready,setReady] = useState(false);
    const [globalFilter,setGlobalFilter] = useState();                  // default values?

    const [users,setUsers] = useState([]);

    const [usersPending,setUsersPending] = useState(false);
    const _users = useSelector(state => state.users_data.users);

    const [selectedDateFrom,setSelectedDateFrom] = useState(searchParams.get("date_lte") !== null ? searchParams.get("date_lte") : null);
    const [selectedDateTo,setSelectedDateTo] = useState(searchParams.get("date_gte") !== null ? searchParams.get("date_gte") : null);

    const [monthList,setMonthList] = useState([]);

    const [selectedQuickfilter,setSelectedQuickfilter] = useState(searchParams.get("quickTime") !== null ? searchParams.get("quickTime") : null);    // default: nothing selected
    const [selectedMonthfilter,setSelectedMonthfilter] = useState(searchParams.get("month") !== null ? searchParams.get("month") : "");      // default; empty field / none


    const onFilterCountChangeHandle = (value) => {
        let clone = {...value};
        let count = 0;
        for (const [type, val] of Object.entries(clone)) {
            if(val){
                count++;
            }
        }
        if(count < 1){
            count = 0;
            $('#inb-selected-filters').addClass('hidden');
        } else {
            $('#inb-selected-filters').removeClass('hidden');
        }
        setFilterCount(count);

    };
    const resetFilter = () =>
    {
        let clone = {
            comlete: true
        };
        setClientFilter(null);
        setPaymentMethodFilter('');
        setPaystateFilter('');
        setSelectedDateFrom(null);
        setSelectedDateTo(null),
        setSelectedQuickfilter(null);
        setSelectedMonthfilter(null);
        setFilterCount(0);
        setUsedFilterCount(cleanState);
        onFilterCountChangeHandle(cleanState);

        const newRelativePathQuery = window.location.pathname;
        history.pushState(null, "", newRelativePathQuery);
        props.filterChangedHandle(clone);
    }
    /**
     * can be generally defined in common sidebar
     * @param {event} ev 
     */
    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    // method can be used to proof if filter combination is valid
    const onClientSelectHandle = (client) => {
        // should validate filter combination and start request
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (client !== '') {
            // add status filter to global filter
            clone.client_id = client;
            clone2.clientFilter = true;
            searchParams.set('client_id', client);
            searchParams.set('client_name', props.clientsN[client]);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['client_id'];
            clone2.clientFilter = false;
            searchParams.delete('client_id');
            searchParams.delete('client_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setClientFilter(client);
        setUsedFilterCount(clone2);

        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        props.filterChangedHandle(clone);
    };


    const onQuickFilterSelectHandle = (value) => {
        // remove all date filter
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        let none = false;
        switch (value) {
            case 'previous_year':
                const prevYear = Number(moment().format('YYYY'))-1;
                clone.date_lte = prevYear + "-12-31%2023:59:59";
                clone.date_gte = prevYear + "-01-01%2000:00:00";
                break;
            case 'current_year':
                const currYear = Number(moment().format('YYYY'));
                clone.date_lte = currYear + "-12-31%2023:59:59";
                clone.date_gte = currYear + "-01-01%2000:00:00";
                break;
            case 'current_month':
                clone.date_lte = moment().endOf('month').format('YYYY-MM-DD 2023:59:59');
                clone.date_gte = moment().startOf('month').format('YYYY-MM-DD 2023:59:59');;
                break;
            case 'previous_month':
                const prevMonth =
                clone.date_lte = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59');
                clone.date_gte = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00:00');
                break;
            case '':
            default:
                delete clone.date_lte;
                delete clone.date_gte;
                none = true;
        }
        clone2.quickTimeFilter = !none;
        if(!none) {
            searchParams.set('quickTime', value);
        } else {
            searchParams.delete('quickTime');
        }
        searchParams.delete('month_name');
        searchParams.delete('month');
        searchParams.delete('date_lte');
        searchParams.delete('date_gte');
        clone2.monthFilter=false;
        clone2.fromFilter = false;
        clone2.toFilter=false;
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setSelectedQuickfilter(value);
        setGlobalFilter(clone);
        // reset datepickers
        if (selectedDateFrom !== null) setSelectedDateFrom(null);
        if (selectedDateTo !== null) setSelectedDateTo(null);
        // reset month filter
        setSelectedMonthfilter("");
        setSelectedQuickfilter(value);


        onFilterCountChangeHandle(clone2);
        props.filterChangedHandle(clone);
    };

    const selectedDateToHandle = (date) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date) {
            clone.date_lte = moment(date).format('YYYY-MM-DD') + '%2023:59:59';

            clone2.toFilter=true;
            setSelectedDateTo(date);
            searchParams.set('date_lte', clone.date_lte);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
             delete clone['date_lte'];
            clone2.toFilter=false;
            setSelectedDateTo('');
            searchParams.delete('date_lte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        // reset month and quick filter
        searchParams.delete('month_name');
        searchParams.delete('month');
        searchParams.delete('quickTime');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setSelectedMonthfilter("");
        setSelectedQuickfilter(null);
        clone2.monthFilter = false;
        clone2.quickTimeFilter = false;
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        props.filterChangedHandle(clone);
    };

    const selectedDateFromHandle = (date) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date) {
            clone.date_gte = moment(date).format('YYYY-MM-DD') + '%2000:59:59';

            clone2.fromFilter=true;
            setSelectedDateFrom(date);
            searchParams.set('date_gte', clone.date_gte);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            delete clone['date_gte'];
            clone2.fromFilter=false;
            setSelectedDateFrom('');
            searchParams.delete('date_gte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        searchParams.delete('month_name');
        searchParams.delete('month');
        searchParams.delete('quickTime');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setGlobalFilter(clone);
        // reset month and quick filter
        clone2.monthFilter = false;
        clone2.quickTimeFilter = false;
        setUsedFilterCount(clone2);
        setSelectedMonthfilter("");
        setSelectedQuickfilter(null);
        onFilterCountChangeHandle(clone2);
        props.filterChangedHandle(clone);
    };

    const dateKeyDownHandle = (e) => {
        console.log("key down date: ",e);
    };

    const onPaymentTypeSelectHandle = (paymentType) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (paymentType !== '') {
            // add status filter to global filter
            clone.payment_type = paymentType;
            clone2.paymentMethodFilter = true;
            searchParams.set('payment_type', paymentType);
            searchParams.set('payment_type_name', t(paymentType,null,'capital'));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['payment_type'];
            clone2.paymentMethodFilter = false;
            searchParams.delete('payment_type');
            searchParams.delete('payment_type_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setPaymentMethodFilter(paymentType);
        setUsedFilterCount(clone2);

        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        props.filterChangedHandle(clone);
    };

    const onPaystateSelectHandle = (payState) => {
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (payState !== '') {
            // add status filter to global filter
            clone.paystate = payState;
            clone2.paymentStatusFilter = true;
            searchParams.set('paystate', payState);
            searchParams.set('payment_status_name', t(payState,null,'capital'));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['paystate'];
            clone2.paymentStatusFilter = false;
            searchParams.delete('paystate');
            searchParams.delete('payment_status_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setPaystateFilter(payState);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        props.filterChangedHandle(clone);
    }

    const onMonthSelectHandle = (month) => {

        // should vaildate filter combo
        // reset all other time or date filter!
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};

        if (month === "") {
            // reset time / date filter
            delete clone.date_lte;
            delete clone.date_gte;
            clone2.monthFilter = false;
            searchParams.delete('month');
            searchParams.delete('month_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            setSelectedMonthfilter("");

        } else {

            //let _month = '' + month;
            //if (_month.length == 1) _month = '0' + _month;

            // compute created_lt and created_gte
            //const prefix = moment().format('YYYY') + '-' + _month + '-01';

            const startOfMonth = moment(month).startOf('month').format('YYYY-MM-DD HH:mm:ss');
            const endOfMonth   = moment(month).endOf('month').format('YYYY-MM-DD HH:mm:ss');

            clone.date_lte = endOfMonth;
            clone.date_gte = startOfMonth;
            clone2.monthFilter = true;
            searchParams.set('month',month);
            searchParams.set('month_name',getNameOfMonth(Number(moment(month).format('MM'))-1));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            //clone.limit = 100000;
        }

        setGlobalFilter(clone);
        clone2.fromFilter = false;
        clone2.toFilter = false;
        clone2.quickTimeFilter = false;
        // reset datepicker
        if (selectedDateFrom !== null) setSelectedDateFrom(null);
        if (selectedDateTo !== null) setSelectedDateTo(null);
        // reset quick filter
        setSelectedQuickfilter(null);
        setSelectedMonthfilter(month);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        searchParams.delete('date_lte');
        searchParams.delete('date_gte');
        searchParams.delete('quickTime');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        // fetch wallet transactions
        props.filterChangedHandle(clone);
    };


    const getNameOfMonth = (m) => {

        switch (m) {
            case 0:
                return t('january');
            case 1:
                return t('february');
            case 2:
                return t('march');
            case 3:
                return t('april');
            case 4:
                return t('may');
            case 5:
                return t('june');
            case 6:
                return t('july');
            case 7:
                return t('august');
            case 8:
                return t('september');
            case 9:
                return t('october');
            case 10:
                return t('november');
            case 11:
                return t('december');
            default:
                return "";
        }
    };

    const initMonthList = () => {

        var month = [{name:'- ' + t('select month') + ' -',value:""}];
        var count = 12;
        const currentMonth = moment().month();
        const currentYear = moment().year();

        for (var i=currentMonth;i>=0;i--) {
            month.push({
                name: getNameOfMonth(i) + " " + currentYear,
                value: currentYear + "-" + (i<9 ? "0" + (i+1) : (i+1) ),
            });
            count--;
        }

        var j=0;
        while (count>0) {
            console.log("name: ",getNameOfMonth(11-j));
            month.push({
                name: getNameOfMonth(11-j) + " " + (currentYear-1),
                value: currentYear-1 + "-" + (j>2 ? "0" + (12-j) : (12-j) )     // value matching format of moment
            });
            count--;
            j++;
        }
        setMonthList(month);
        setReady(true);
    };


    const initialize = () => {

        if (ready) return;

        initMonthList();
    };

    if (!ready) initialize();

    return (
        <aside
            id="inb-c-sidebar"
            className="filemanager-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title">
                <h1 className="inb-page-title">
                {props.heading}
                </h1>
            </header>
            <aside id="inb-selected-filters">
                {filterCount > 0 && <ul>
                    <p>
                        <i className="fi fi-filter"> </i>
                        <span id="inb-selected-filters__count">
                               {" " + filterCount}
                             </span>

                        {" " + t('filter_selected')}
                        <a href="#"
                           id="inb-selected-filters__unset"
                           className="unset-filter"
                           title={t('unselect_all_filter')} onClick={(e) => {
                            resetFilter(e)
                        }}>
                            x
                        </a>
                    </p>
                </ul>}
            </aside>
            {!ready &&
            <Loader
                mediumWidth={4}
                smallWidth={4}
                subLoaders={2}/>
            }
            {ready &&
              <>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-clients"
                    heading={t('clients')}
                    type="select"
                    data={props.clients}
                    dataKey="value"
                    onChangeHandle={onClientSelectHandle}
                    selected={clientFilter !== 'all'?clientFilter:null}
                    placeholder={'- ' + t('all',null,'capital') + ' -'}/> 
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-payment-method"
                    heading={t('payment_type')}
                    type="select"
                    data={[{
                        name:'- ' + t('all',null,'capital') + ' -', value:''},{
                        name:t('PayPal',null,'capital'),value:'PayPal'},{
                        name:t('sepa_debit',null,'capital') + ' (online)',value:'sepa_debit'},{
                        name:t('credit',null,'capital') + ' (online)',value:'Credit'},{
                        name:t('googlePay',null,'capital') + ' (online)',value:'googlePay'},{
                        name:t('applePay',null,'capital') + ' (online)',value:'applePay'
                    }]}
                    dataKey="value"
                    selected={paymentMethodFilter !== null?paymentMethodFilter:null}
                    onChangeHandle={onPaymentTypeSelectHandle}/>
                 {/* <SidebarFilter
                      id="inb-c-left-bar-flist--transactions-paystate"
                      heading={t('paystate')}
                      type="select"
                      data={[{
                          name:'- ' + t('all',null,'capital') + ' -', value:''},{
                          name:t('paid',null,'capital'),value:'paid'},{
                          name:t('refunded',null,'capital'),value:'refund'}]}
                      dataKey="value"
                      selected={paystateFilter !== null?paystateFilter:null}
                      onChangeHandle={onPaystateSelectHandle}/>*/}
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-date"
                    heading={t('timespan',null,'capital')}
                    type="datePicker"
                    data={[{
                        name: "date_from",
                        className: "noBorders-noBackground",
                        dateFormat: "dd.MM.y",
                        selected: selectedDateFrom,
                        onChangeHandle: selectedDateFromHandle,
                        onKeyDownHandle: dateKeyDownHandle,
                        placeholder: t('valid_from',null,'capital') + ' ...'
                    },{
                        name: "date_to",
                        className: "noBorders-noBackground",
                        dateFormat: "dd.MM.y",
                        selected: selectedDateTo,
                        onChangeHandle: selectedDateToHandle,
                        onKeyDownHandle: dateKeyDownHandle,
                        placeholder: ' ...' + t('valid_to',null,'capital'),
                    }]}/>
                <SidebarFilter
                        id="inb-c-left-bar-flist--transactions-payment-method2"
                        heading=""
                        type="list"
                        data={[{name:t('previous_year'),value:'previous_year'},
                               {name:t('current_year'),value:'current_year'},
                               {name:t('current_month'),value:'current_month'},
                               {name:t('previous_month'),value:'previous_month'}]}
                        dataKey="value"
                        selected={selectedQuickfilter !== null ? selectedQuickfilter : 'nothingAtAllCauses'}
                        onChangeHandle={onQuickFilterSelectHandle}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-month"
                    heading=""
                    type="select"
                    data={monthList}
                    dataKey="value"
                    selected={selectedMonthfilter}
                    onChangeHandle={onMonthSelectHandle}/>
              </>
            }
            <footer className="inb-c-left-bar__footer small-only-float-container center-on-content">
                <a href="#"
                    id="toggle-left-bar"
                    className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                        <i className="fi fi-filter"></i>
                        <span className="show-for-sr">t('open_filter_menu')</span>
                </a>
            </footer>
        </aside>
    );
};

export default AdminTransactionsSidebar;

